/* eslint-disable max-len */
import { HealthSurveillanceQuestionConfig, MedicalTypeIds } from "../models";

import * as questionIds from "./questionIds";

const section8MedicalTypes = [
    MedicalTypeIds.Audiometry,
    MedicalTypeIds.SafetyCriticalWorker,
    MedicalTypeIds.WorkAtHeight,
    MedicalTypeIds.WorkingConfinedSpaces,
    MedicalTypeIds.WorkingThermalEnvironment,
    MedicalTypeIds.Offshore,
    MedicalTypeIds.Airside,
    MedicalTypeIds.OtherFitnessToWork
];

/**
 * @deprecated Prefer sections exported from `import { sections } from "../questionnaire";` which is in a data structure suitable for use with custom medicals
 */
export const section8Questions: HealthSurveillanceQuestionConfig[] = [
    {
        id: questionIds.OccupationalNoiseExposedTo,
        questionText: "Current type of occupational noise you are exposed to",
        medicalTypes: section8MedicalTypes
    },
    {
        id: questionIds.HowLongExposedToNoise,
        questionText: "How often are you exposed to noise and for how long?",
        medicalTypes: section8MedicalTypes
    },
    {
        id: questionIds.HobbiesExposedToNoise,
        questionText: "Please list any hobbies that expose you to noise",
        medicalTypes: section8MedicalTypes
    },
    {
        id: questionIds.EarInjuriesInfectionsDiseases,
        questionText: "Have you had any injuries, infections or diseases affecting the ears?",
        medicalTypes: section8MedicalTypes
    },
    {
        id: questionIds.EarInjuriesInfectionsDiseasesFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section8MedicalTypes
    },
    {
        id: questionIds.NoisesInEars,
        questionText: "Are you aware of any noises (tinnitus) in the ears?",
        medicalTypes: section8MedicalTypes
    },
    {
        id: questionIds.NoisesInEarsFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section8MedicalTypes
    },
    {
        id: questionIds.EarDischargeOrWaxBuildUp,
        questionText: "Are you aware of any discharge from the ears or history of waxy deposit build up?",
        medicalTypes: section8MedicalTypes
    },
    {
        id: questionIds.EarDischargeOrWaxBuildUpFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section8MedicalTypes
    },
    {
        id: questionIds.DifficultWithHearing,
        questionText: "Do you have any difficult with your hearing?",
        medicalTypes: section8MedicalTypes
    },
    {
        id: questionIds.DifficultWithHearingFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section8MedicalTypes
    },
    {
        id: questionIds.EverKnockedUnconscious,
        questionText: "Have you ever been knocked unconscious?",
        medicalTypes: section8MedicalTypes
    },
    {
        id: questionIds.EverKnockedUnconsciousFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section8MedicalTypes
    },
    {
        id: questionIds.DizzinessOrVertigo,
        questionText: "Do you get dizziness or vertigo?",
        medicalTypes: section8MedicalTypes
    },
    {
        id: questionIds.DizzinessOrVertigoFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section8MedicalTypes
    },
    {
        id: questionIds.EverHearingLostDueToIllness,
        questionText: "Have you ever suffered from hearing loss due to an illness?",
        medicalTypes: section8MedicalTypes
    },
    {
        id: questionIds.EverHearingLostDueToIllnessFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section8MedicalTypes
    },
    {
        id: questionIds.EarDiseaseOrDeafnessInFamily,
        questionText: "Do you have any ear disease or deafness in the family?",
        medicalTypes: section8MedicalTypes
    },
    {
        id: questionIds.EarDiseaseOrDeafnessInFamilyFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section8MedicalTypes
    },
    {
        id: questionIds.ExposureGunfireExplosions,
        questionText: "Exposure to gunfire or explosions?",
        medicalTypes: section8MedicalTypes
    },
    {
        id: questionIds.ExposureGunfireExplosionsFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section8MedicalTypes
    },
    {
        id: questionIds.ExposureNoisePreviousOccupation,
        questionText: "Exposure to noise in a previous occupation?",
        medicalTypes: section8MedicalTypes
    },
    {
        id: questionIds.ExposureNoisePreviousOccupationFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section8MedicalTypes
    },
    {
        id: questionIds.ExposureNoiseLeisureActivities,
        questionText: "Exposure to noise in your leisure activities, e.g. at concerts, motorcycles, shooting, DIY?",
        medicalTypes: section8MedicalTypes
    },
    {
        id: questionIds.ExposureNoiseLeisureActivitiesFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section8MedicalTypes
    },
    {
        id: questionIds.TakingMedicationAffectingHearing,
        questionText: "Are you taking any medication that may affect your hearing?",
        medicalTypes: section8MedicalTypes
    },
    {
        id: questionIds.TakingMedicationAffectingHearingFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section8MedicalTypes
    },
    {
        id: questionIds.ExposedNoisyEnvironmentLast48Hours,
        questionText: "Have you been exposed to a noisy environment in the last 48 hours?",
        medicalTypes: section8MedicalTypes
    },
    {
        id: questionIds.ExposedNoisyEnvironmentLast48HoursFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section8MedicalTypes
    },
    {
        id: questionIds.WornEarProtectionLast48Hours,
        questionText: "Have you worn ear protection in the last 48 hours?",
        medicalTypes: section8MedicalTypes
    },
    {
        id: questionIds.WornEarProtectionLast48HoursFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section8MedicalTypes
    },
    {
        id: questionIds.WearEarProtectionWhenAdvised,
        questionText: "Do you wear ear protection when advised?",
        medicalTypes: section8MedicalTypes
    },
    {
        id: questionIds.WearEarProtectionWhenAdvisedType,
        questionText: "What type?",
        medicalTypes: section8MedicalTypes
    },
    {
        id: questionIds.WearEarProtectionWhenAdvisedFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section8MedicalTypes
    },
    {
        id: questionIds.WearEarProtectionPreviousEmployment,
        questionText: "Have you ever worn ear protection in previous employment?",
        medicalTypes: section8MedicalTypes
    },
    {
        id: questionIds.WearEarProtectionPreviousEmploymentType,
        questionText: "What type?",
        medicalTypes: section8MedicalTypes
    },
    {
        id: questionIds.WearEarProtectionPreviousEmploymentFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section8MedicalTypes
    }
];
/* eslint-enable max-len */
